
import type { CreateElement } from 'vue';
import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component<DropdownItem>({
  name: 'DropdownItem',
})
export default class DropdownItem extends Vue {
  @Prop({ default: false }) custom!: boolean;
  @Prop({ default: false }) separated!: boolean;
  @Prop({ default: false }) muted!: boolean;
  @Prop({ default: false }) selected!: boolean;
  // For <a> instead of <NuxtLink>
  @Prop({ default: false }) external!: boolean;
  @Prop({ default: '' }) link!: '';

  get className(): Record<string, boolean> {
    return {
      'dropdown-item': true,
      'dropdown-item--default': !this.custom,
      'dropdown-item--separated': this.separated,
      'dropdown-item--selected': this.selected,
      'dropdown-item--muted': this.muted,
    };
  }

  get type(): string {
    if (this.link) {
      return this.isExternal ? 'a' : 'NuxtLink';
    }
    return 'div';
  }

  /**
   * Links starts from http is automatically external, but
   * we still have a case when link should be outside vue-router
   */
  get isExternal() {
    if (typeof this.link === 'string') {
      return this.link?.match(/^https?:\/\//) || this.external;
    }
    return this.external;
  }

  render(h: CreateElement) {
    const defaultAttrs = {
      role: 'option',
    };
    const props = this.link ? { to: this.link } : {};
    const attrs = this.link && this.isExternal ? { href: this.link } : {};

    return h(
      this.type,
      { class: this.className, props, attrs: { ...defaultAttrs, ...attrs }, on: this.$listeners },
      this.$slots.default,
    );
  }
}
